module.exports = __webpack_public_path__ + "static/media/AnimationsBadUncropped.5839765d.gif";